<template>
  <div class="grid grid-rows-[1fr_auto] h-full overflow-y-hidden md:overflow-y-auto w-full">
    <div class="flex flex-col w-full mb-2 h-full overflow-y-auto px-4 md:px-0">
      <div v-if="complementaryServices.length > 0" class="w-full flex flex-col md:flex-row md:flex-wrap gap-3 md:gap-6">
        <service-card v-for="service of complementaryServices"
                      :key="service.id"
                      :service="service"
                      @clicked-edit="clickedEdit"
        />
        <div v-if="isMobile" class="h-4 p-2 flex-none"></div>
      </div>
      <div v-else class="w-full h-max flex flex-col justify-center items-center my-auto">
        <img
          src="../../../../../assets/img/admin/create-services.svg"
          class="w-44 mb-4"
          alt="יצירת תוכנית נאמנות">
        <span class="text-lg font-medium">נראה שעוד לא יצרתם שירות משלים</span>
        <span class="text-center px-4 font-light"> שירותים משלימים הם שירותים שנציע ללקוח לאחר שהוא כבר בחר את השירות המבוקש והזמן הרצוי.</span>
        <span class="text-center px-4 font-light">הוסיפו שירותים משלימים כדי להגדיל מכירות בעסק שלכם!</span>
        <div
          class="relative py-2 px-4 border border-solid m-2 bg-primary-500 text-white rounded-3xl border-purple-800 flex gap-2 justify-center items-center mt-4"
          @click="addNewService">
          <i class="pi pi-verified" />
          <span class="text-sm">הוספת שירות משלים</span>
        </div>

      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { IService, ServiceType } from '@torim-app/types';
import { computed, ref } from 'vue';
import { useAdminStore } from '@app/stores';
import AddOrEditService from '@app/components/admin/modals/AddOrEditService.vue';
import { useDrawer } from '@torim-app/shared-components';
import { useResponsive } from '@app/composables/responsive';
import { trackEvent } from '@app/composables/posthog';

const adminStore = useAdminStore();
const { openDrawer, closeDrawer } = useDrawer();
const { isMobile } = useResponsive();

const selectedServiceToEdit = ref<IService>();

const isMainClient = computed(() => adminStore.getMainClient);
const complementaryServices = computed<Array<IService>>(() => adminStore.getComplementaryServices);

const addNewService = () => {
  trackEvent('add_service_clicked', { source: 'upsell_services_page', service_type: 'complementary' });
  selectedServiceToEdit.value = undefined;
  openDrawer(AddOrEditService, { serviceType: ServiceType.COMPLEMENTARY, service: undefined, mode: 'create', onClose: closeDrawer }, { title: 'הוספת שירות משלים חדש' });
};

const clickedEdit = (service: IService) => {
  trackEvent('edit_service_clicked', { source: 'upsell_services_page', service_type: 'complementary' });
  selectedServiceToEdit.value = service;
  openDrawer(AddOrEditService, { serviceType: ServiceType.COMPLEMENTARY, service, mode: 'edit', onClose: closeDrawer }, { title: 'עריכת שירות משלים' });
};


</script>

<style lang="scss">
@use '../../../../../assets/css/vars' as *;
@use '../../../../../assets/css/transitions' as *;

.services {
  display: flex;
  align-items: center;
  flex-direction: column;
  width: 100%;
  margin-bottom: 0.5rem;

  .service {
    width: 100%;
    margin-bottom: 1rem;
    border: 1px #efefef solid;
    border-radius: 0.35rem;
    display: flex;
    flex-direction: column;

    &.close {
      .header {
        border-radius: 0.35rem;
      }
    }

    &.hidden {
      opacity: 0.5;
    }

    .header {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
      background: #efefef;
      padding: 0.5rem;
      margin-bottom: 0.5rem;
    }

    .content {
      padding: 0 1rem;
      display: flex;
      flex-direction: column;

      .service-row {
        display: flex;
        flex-direction: row;
        align-items: flex-end;
        margin-bottom: 0.25rem;

        .text-sm {
          line-height: 1.15rem !important;
        }

        span:first-child {
          margin-left: 0.35rem;
        }
      }

      .flex flex-col gap-1 {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        margin-bottom: 0.25rem;

        span:first-child {
          margin-bottom: 0.35rem;
        }
      }

      .preview {
        display: flex;
        align-items: center;
        justify-content: space-evenly;
      }
    }
  }
}

.save-button {
  width: 100%;
}
</style>
